export enum FormaTanque {
    CilindricoVertical,
    Vertical,
    Horizontal,
    Enterrado,
    EnterradoDoblePared,
}